<div id="zaaDialog" class="modal modal-lg modal-dialog fade in" role="dialog" style="display: none;position:absolute !important" 
    appDraggable dragTarget="#zaaDialog" dragHandle="#zaaDialogHeader" data-backdrop="static" data-keyboard="false">
  <div class="modal-content">
    <!-- Header -->
    <div class="modal-header" id="zaaDialogHeader">
      <button type="button" class="close" (click)="hide()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
      <h4 class="modal-title"><i class="fa fa-refresh"></i> Assigned Assets for Zone: {{ zaa?.zone?.name }}</h4>
    </div>

    <!-- Body -->
    <div class="modal-body internal-well">
      <!-- Results Header -->
		  <div class="page-button">
        <!--Add Button -->
			  <button class="btn btn-ef" type="button" (click)="onAddClicked()">
          <i class="fa fa-plus" aria-hidden="true"></i> ADD ASSET
        </button>
      </div>

      <!-- Results -->
      <table class="table tablesorter tablesorter-default table-hover" data-toggle="table" role="grid">
        <!-- Headers -->
        <thead>
          <tr role="row" class="tablesorter-headerRow">
            <!-- ACTION Icons -->
            <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;">
            </th>

            <!-- Asset Name -->
            <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;">
              <div class="tablesorter-header-inner">ASSET NAME</div>
            </th>

            <!-- Asset Type -->
            <th class="header tablesorter-header tablesorter-headerUnSorted" style="user-select: none;">
              <div class="tablesorter-header-inner">ASSET TYPE</div>
            </th>
          </tr>
        </thead>
        <!-- Data -->
        <tbody aria-live="polite" aria-relevant="all">
          <ng-container *ngFor="let asset of assignedAssets">
            <tr>
              <!-- ACTION Icons-->
						  <td>
                <em class="fa fa-trash" style="cursor: pointer"(click)="onDeleteClicked(asset)"></em>
                <!--
                &nbsp;&nbsp;&nbsp;
                <em class="fa fa-pencil" (click)="editRowClicked(gtinDetails)"></em>
                -->
              </td>

              <!-- Asset Name -->
              <td>
                {{ asset.name }}
              </td>

               <!-- Asset Type -->
              <td>
                {{ asset.type_name }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="onCancelClicked()">
        <i class="fa fa-ban" aria-hidden="true"></i> CANCEL
      </button>
      <button (click)="onUpdateClicked()" class="btn btn-primary">
        <i class="fa fa-refresh"></i> UPDATE
      </button>
    </div>
</div>

<!-- Dialog used to allow the User to add an Asset -->
<ef-add-asset-dialog (assetSelected)="onAssetSelected($event)"></ef-add-asset-dialog>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog></ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>